module.exports = {"140671400":"山西朔州经济开发区街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140671.json
// module id = 407
// module chunks = 0